import { blocksConfig } from './blocksConfig.js';
import { editorConfig } from './editorConfig.js';
const configs = {
    Editor: editorConfig,
    Blocks: blocksConfig
};
export const getConfig = (structureType) => {
    const config = configs[structureType];
    if (!config) {
        throw new Error('Unknown file structure type: ' + structureType);
    }
    return config;
};
